import Customer from '@/model/customer/Customer'
import {TagResponseItem} from '@/types/service-response'

export interface BoarderGroupModel {
  id: number
  name: string
  customer: Customer | undefined
}

export interface BoarderGroupResponseModel {
  id: number
  name: string
  businessCustomer: {
    customer: Customer
  },
  slotPrices: {
    menuGroupSlot: {
      id: number
    },
    price: number
  }[]
  priceAlgorithm: {
    id: number | null
  }
  tags: TagResponseItem[]
}

export type BoarderGroupResponse = BoarderGroupResponseModel[]

export default class BoarderGroup {
  private constructor (
    readonly id: number,
    readonly name: string,
    readonly customer: Customer | undefined
  ) {

  }

  get iri(): string {
    return `/api/boarder-group/${this.id}`
  }

  public static createFromModel (data: Partial<BoarderGroupModel>): BoarderGroup {
    return new BoarderGroup(
      data.id!,
      data.name!,
      data.customer || undefined
    )
  }

  public static createFromResponse (data: BoarderGroupResponse): BoarderGroup[] {
    return data.map((item: BoarderGroupResponseModel) => {
      return BoarderGroup.createFromModel({
        id: item.id,
        name: item.name,
        customer: item.businessCustomer.customer
      } as BoarderGroupModel)
    })
  }
}